import { wsDriver } from '@leagueplatform/masonry';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
} from 'common/constants/masonry';
import { HeroBanner } from 'components/hero-banner/hero-banner.component';

export const initDefaultWSRegistry = () => {
  wsDriver.nodeRendererRegistry.overrideRenderer(
    MASONRY_WIDGET_TYPES.HERO_BANNER,
    MASONRY_NAMESPACES.DEFAULT,
    HeroBanner,
  );
};
